// extracted by mini-css-extract-plugin
export default {"mainHeader":"ConfigMembershipCardsHeader_mainHeader__OUN7d","selectACard":"ConfigMembershipCardsHeader_selectACard__SyGrV"};